<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">

          <div class="mb-8" style="font-size: 1.1rem; font-weight: 700; color: var(--v-mainColor-base);">
            {{ $store.getters.whiteGloveFamilyProgramName }} orders history
          </div>

          <b-table
            class="orders-table mb-10"
            striped
            :data="records"
            :loading="isLoading"
            :paginated="records.length > 100"
            :default-sort="['order_date_timestamp', 'desc']"
            per-page="100"
          >
            <template slot-scope="props">
              <b-table-column field="order_date_timestamp" label="Date ordered" sortable sort-column="order_date_timestamp">{{ props.row.order_date }}</b-table-column>
              <b-table-column field="id" label="Order Number" sortable>{{ props.row.id }}</b-table-column>
              <b-table-column field="type" label="Order Type" sortable>{{ getOrderTypeLabel(props.row.type) }}</b-table-column>
              <b-table-column field="site_name" label="Project" sortable><router-link :to="`/sites/${props.row.site_id}/tools`">{{ props.row.site_name }}</router-link></b-table-column>
              <b-table-column field="price_on_checkout" label="Amount paid" sortable>{{ getAmountPaidLabel(props.row) }}</b-table-column>
              <b-table-column field="fulfillement_status" label="Status" sortable><span :style="`color: ${getFulfillementStatusColor(props.row.fulfillement_status) || 'inherit'}`"><span style="font-size: 1.3rem; margin-right: 4px;">•</span> {{ getFulfillementStatusLabel(props.row.fulfillement_status) }}</span></b-table-column>
              <b-table-column field="action" label="Action" sortable><router-link class="view-order-link" :to="getOrderPath(props.row)">View order</router-link></b-table-column>
            </template>
          </b-table>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { toLocalDateString, formatCurrency } from '@/utils'
import {
  AVAILABLE_SALES_TAGS,
  WHITE_GLOVE_CAMPAIGN_MANAGERS,
} from "@/components/plans_constants"
import moment from 'moment'
import 'vue2-datepicker/index.css';

export default {
  data() {
    return {
      records: [],
      isLoading: false,
      WHITE_GLOVE_CAMPAIGN_MANAGERS: WHITE_GLOVE_CAMPAIGN_MANAGERS,
      AVAILABLE_SALES_TAGS: AVAILABLE_SALES_TAGS,
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.user
    },
  },
  methods: {
    formatCurrency: formatCurrency,
    /** POP Authority package months are covered by the monthly subscription. */
    getAmountPaidLabel(order) {
      if (order.included_in_package || order.includedInPackage) {
        return 'Included'
      }
      return formatCurrency(order.price_on_checkout)
    },
    getOrderPath(order) {
      if (order.type === 'silo_order') {
        return `/sites/${order.silo.siteId}/content-plans/${order.siloId}`
      }
      if (order.type === 'quick_content_order') {
        return `/sites/${order.silo.siteId}/all-content/quick/${order.siloId}`
      }
      if (order.type === 'audit_order') {
        return `/sites/${order.site_id}/overview`
      }
      if (order.type === 'package_invoice') {
        return `/sites/${order.site_id}/packages`
      }
      if (order.type === 'booster_order') {
        return `/sites/${order.site_id}/boosters`
      }
      return null;
    },
    getOrderTypeLabel(value) {
      if (value === 'silo_order') {
        return 'Content Plan'
      }
      if (value === 'quick_content_order') {
        return 'Content Only'
      }
      if (value === 'audit_order') {
        return 'Site Content Audit'
      }
      if (value === 'package_invoice') {
        return 'POP Authority package month'
      }
      if (value === 'booster_order') {
        return 'POP Authority booster'
      }
      return value;
    },
    getFulfillementStatusLabel(status) {
      if (status === 'pending') {
        return 'Ordered'
      }
      if (status === 'in_progress') {
        return 'In progress'
      }
      if (status === 'completed') {
        return 'Completed'
      }
      return status;
    },
    getFulfillementStatusColor(status) {
      if (status === 'in_progress') {
        return '#316BFF'
      }
      if (status === 'completed') {
        return '#25A97A'
      }
      return null;
    },
    toLocalDateString(dateStr) {
      return toLocalDateString(dateStr)
    },
    loadData() {
      this.isLoading = true
      this.$store.commit('showLoading')

      return this.$store.dispatch('getWhiteGloveOrders')
        .then((response) => {
          this.records = response.data.data
        })
        .finally(() => {
          this.isLoading = false
          this.$store.commit('hideLoading')
        })
    },
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style lang="scss">
.view-order-link {
  text-decoration: underline;
  font-weight: 700;
  color: #0075FF !important;
}

.orders-table {
  .table.is-striped tbody tr:not(.is-selected):nth-child(2n) {
    background-color: #f7f5fb;
  }
  .table {
    border: 1px solid var(--v-gray15Color-base) !important;
    border-radius: 6px !important;
  }
  th, td {
    padding: 14px !important;
  }
}
</style>
